import { useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const ShowRoadmapInfo = () => {
    const { roadmaps } = useSelector((state: RootState) => state.mapScreen)
    const firstRoadmap = roadmaps[0]; // Проверяем, есть ли данные
    const navigate = useNavigate();

  const clickClose = () => {
    navigate(-1); 
  };

    return (
        <Container>
            <ContainerInputsForm>
                {firstRoadmap.route_name && <Text>Путь следования рейса по маршруту: {firstRoadmap.route_name}</Text>}
                {firstRoadmap.route_description && <Text>{firstRoadmap.route_description}</Text>}
                {firstRoadmap.tc_name && <Text>{firstRoadmap.tc_name}</Text>}
            </ContainerInputsForm>
            <CloseButton onClick={clickClose}>X</CloseButton>
        </Container>
    )
}

export default ShowRoadmapInfo;

const Container = styled.div`
   display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 1;
    background-color: white;
    border-radius: 14px;
    left: 30px;
    top: 30px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    transition: right 0.5s;
    `

const CloseButton = styled.button`
    background: transparent;
    border: none;
    font-size: 17px;
    cursor: pointer;
    color: #333;
    font-weight: bold;
    padding-left: 10px;
    padding-right: 20px;

    &:hover {
        color: red;
    }
`;

const ContainerInputsForm = styled.div`
    padding: 7px 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0px;`

const Text = styled.p`
    font-size: 15px;
    font-weight: 700;
    margin: 0;
    padding: 10px 0 5px;
`;